import { Form, FormField, IFormField, RequiredValidator } from '@thinknimble/tn-forms'
import { SelectOption } from '../base-model'

export type ExportTemplateFormInputs = {
  _name: IFormField<string>
  organization: IFormField<SelectOption | undefined>
  columnConfig: IFormField<string[]>
}

export class ExportTemplateForm extends Form<ExportTemplateFormInputs> {
  static _name = new FormField({
    label: 'Template Name',
    placeholder: 'e.g. Monthly Summary',
    validators: [new RequiredValidator({ message: 'Please enter a template name' })],
  })

  static organization = new FormField({
    label: 'Organization',
    placeholder: 'Select an organization',
    validators: [new RequiredValidator({ message: 'Please select an organization' })],
  })

  static columnConfig = new FormField({
    label: 'Column Configuration',
    placeholder: '',
    validators: [],
    value: [] as string[],
  })

  get val() {
    const columnConfig = (this.field.columnConfig.value || []).map((key: string) => {
      const [source, field] = key.split(':')
      return { source, field }
    })

    return {
      name: this.field._name.value,
      organization: this.field?.organization?.value?.value,
      columnConfig,
    }
  }
}

export type TExportTemplateForm = ExportTemplateForm & ExportTemplateFormInputs
